import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { auth, db } from "../firebase";
import { doc, getDoc, getDocs, query, collection, where } from "firebase/firestore";
import "./../App.css"
import { useNavigate } from "react-router-dom";

function Menu() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("Guest");
    const [userData, setUserData] = useState(null);
    const [propertyStatus, setPropertyStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [propertyName, setPropertyName] = useState("");
    const [propertyLogo, setPropertyLogo] = useState("");
    const [documentStatus, setDocumentStatus] = useState(null);

    const [openMenu, setOpenMenu] = useState(null);


    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                if (!userData) return;

                const userRef = doc(db, "users", userData.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const user = userSnap.data();
                    setUsername(user.name || "Guest");

                }

                setLoading(false);
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, [userData]);



    const linkStyle = {
        color: "#fff",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "15px 15px",
        borderRadius: "8px",
        transition: "all 0.3s ease",
        textDecoration: "none",
        borderBottom: "1px solid rgba(245, 238, 238, 0.2)",
        cursor: "pointer",
        position: "relative"
    };

    const linkHover = {
        background: "rgba(255,255,255,0.15)",
        transform: "translateX(6px)"
    };

    const submenuStyle = {
        paddingLeft: "25px",
        background: "rgba(255,255,255,0.07)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
        display: "block"
    };

    const iconStyle = {
        fontSize: "20px",
        width: "45px",
        textAlign: "center"
    };

    const arrowIconStyle = {
        marginLeft: "auto",
        transition: "0.3s",
        fontSize: "14px"
    };

    const firstLetter = username.charAt(0).toUpperCase();


    const fullMenu = [

        {
            icon: "fas fa-utensils",
            text: "Canteen Mgmt",
            submenu: [
                { text: "Daily Entry", link: "/canteen-daily-entry" },
                { text: "Meal Planning", link: "/meal-planning" },
                { text: "Canteen Menu", link: "/canteen-menu" },
                { text: "Canteen Staff", link: "/canteen-staff" },
            ]
        },
       

    ];

    const menuToShow = fullMenu;


    return (
        <aside
            className="main-sidebar"
            style={{
                background: "linear-gradient(180deg, #096065 0%, #126668 50%, #08456a 100%)",
                backgroundBlendMode: "soft-light",
                backgroundSize: "cover",
                color: "#fff",
                height: "100vh",
                width: "260px",
                position: "fixed",
                top: 0,
                left: 0,
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* TOP PROFILE BAR */}
            <div
                style={{
                    textAlign: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                    padding: "15px 10px",
                    position: "sticky",
                    top: 0,
                    background: "rgba(1, 40, 43, 0.8)",
                    backdropFilter: "blur(6px)",
                    zIndex: 10,
                }}
            >
                {propertyLogo ? (
                    <img
                        src={propertyLogo}
                        alt="Property Logo"
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            margin: "0 auto 10px auto",
                            display: "block",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            background: "#fff"
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(255,255,255,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "28px",
                            fontWeight: "700",
                            margin: "0 auto 10px auto",
                            color: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
                        }}
                    >
                        {firstLetter}
                    </div>
                )}


                <h5 style={{ fontWeight: "600", margin: 0 }}>{username}</h5>

                {propertyName && (
                    <p style={{
                        fontSize: "13px",
                        margin: "4px 0 0",
                        color: "#e0e0ff",
                        fontWeight: "500"
                    }}>
                        {propertyName}
                    </p>
                )}


            </div>

            {/* MENU AREA */}
            {/* MENU AREA */}
            <div
                className="sidebar-scroll"
                style={{
                    padding: "5px 1px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    flex: 1,
                    height: "calc(100vh - 120px)",
                    paddingBottom: "40px"
                }}
            >


                {menuToShow.map((item, index) => (
                    <div
                        key={index}
                        className="menu-parent"
                        style={{ position: "relative" }}

                    >

                        <motion.div
                            onClick={(e) => {
                                if (item.submenu) {
                                    e.preventDefault();
                                    setOpenMenu(openMenu === index ? null : index);
                                } else if (item.link) {
                                    navigate(item.link); // <-- use navigate
                                }
                            }}
                            style={linkStyle}
                            whileHover={linkHover}
                        >
                            <i className={item.icon} style={iconStyle}></i>
                            <span>{item.text}</span>

                            {item.submenu && (
                                <i
                                    className="fas fa-chevron-right arrow-icon"
                                    style={{
                                        ...arrowIconStyle,
                                        transform: openMenu === index ? "rotate(90deg)" : "rotate(0deg)"
                                    }}
                                ></i>
                            )}
                        </motion.div>


                        {item.submenu && openMenu === index && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    overflow: "hidden",
                                }}
                            >
                                {item.submenu.map((sub, sIndex) => (
                                    <motion.div
                                        key={sIndex}
                                        onClick={() => {
                                            if (sub.link) navigate(sub.link);
                                        }}
                                        style={{ ...linkStyle, ...submenuStyle, cursor: "pointer" }}
                                        whileHover={linkHover}
                                    >
                                        • {sub.text}
                                    </motion.div>
                                ))}
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>
        </aside>
    );
}

export default Menu;
